import React from 'react';

import Modal from 'components/ModalProvider/Modal/Modal';
import RequiredChangePassword from './RequiredChangePassword';

const RequiredChangePasswordModal = ({ canClose = false, onSuccess, closeFunction }) => (
  <Modal
    withoutBG
    disableOverlayClose={!canClose}
    closeFunction={closeFunction}
    content={<RequiredChangePassword canClose={canClose} onSuccess={onSuccess} />}
  />
);

export default RequiredChangePasswordModal;